package com.shadowings.gero.data.lessons.chapter3

import androidx.compose.foundation.layout.Row
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*

fun getEurekaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_incredibile_abbiamo_appena_fatto_una_scoperta,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_ti_ricordi_la_scritta_misteriosa_sulla_mummia,
            face = Faces.Serious,
            composable = {
                Row {
                    MdCWord("M23-L2", rtl = false, cart = false)
                    MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true)
                }
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_ora_conosciamo_anche_il_secondo_segno_della_p,
            face = Faces.Surprised,
            composable = {
                MdCWord("L2", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_,
            face = Faces.Happy,
            composable = {
                MdCWord("M23-L2", rtl = false, cart = false, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_si_legge_nswt_bity_ed_il_titolo_reale_re_dell,
            face = Faces.Perfect,
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_e_guarda_la_seconda_parola_racchiusa_nel_cart,
            face = Faces.Surprised,
            composable = {
                MdCWord("V28-D36:Q3-M17-G43B-S34", rtl = false, cart = true, size = 96.dp)
            },
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_per_ora_che_ci_penso_non_ti_ho_ancora_spiegat,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_eureka,
            content = Res.string.exp_content_presto_al_prossimo_capitolo,
            face = Faces.Perfect,
        )
    )
}
